export class FileOnlineUtil {
  static areAinsEqual(ain1: string, ain2: string): boolean {
    return this.stripDashes(ain1) === this.stripDashes(ain2);
  }
  static stripDashes(ain: string): string {
    return ain.replace(/-/g, '');
  }

  static insertDashesAin(ain: string): string {
    if (ain.length === 12) { return ain; } // 10 digits, 2 dashes
    const stripped = this.stripDashes(ain);
    return stripped.substring(0, 4) + '-' + stripped.substring(4, 7) + '-' + stripped.substring(7);
  }
}
